import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getReturnCustomerHistory } from "./schema/get-return-customer-history";
import { getReturnPlatformActivity } from "./schema/get-return-platform-activity";
import { getReturnProcessingProgress } from "./schema/get-return-processing-progress";

/** Reads the return details page makes beside getReturn, each off the page's critical path. */
export const rpcDefinition = {
  getReturnCustomerHistory,
  getReturnPlatformActivity,
  getReturnProcessingProgress,
};

export type RedoReturnDetailsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
